export default "__VITE_ASSET__DdFCHP1c__"